import runtime from '../src/runtime/locales/en-US';
import renderer from '../src/renderer/locales/en-US';
import dataitem from '../src/components/locales/en-US';
export default {
    runtime,
    renderer,
    dataitem
};
